<template>
  <div class="storeCallDiv">
    <!-- 叫号中 -->
    <div class="cont3">
      <div
        class="mgBottom10"
        v-for="(item, index) in vehicleArr"
        :key="index"
        style="display: flex;background: #f9f9fa;"
      >
        <div class="cont3-left">
          <div class="top">{{ item.code }}</div>
          <div style="padding: 0px 0px 0px 10px;display: flex;">
            <div class="left1" v-if="item.report_info">
              {{ item.report_info.license_plate }}
            </div>
            <div class="left2">
              {{
                item.report_info.vehicle_type === 0
                  ? "--"
                  : vehicleColumns[item.report_info.vehicle_type - 1]
              }}
            </div>
          </div>
          <div style="padding: 10px 0px 0px 10px;display: flex;" v-if="!type">
            <div class="left3">
              输入装卸平台<template v-if="business_type == 1"><span style="color: red;">*</span></template> 
            </div>
            <div class="left2" @click="showStore(index)">
              <div
                class="left2-div1"
                :style="
                  item.warehouse.store_name === '请选择装货位' ||
                  item.warehouse.store_name === ''
                    ? 'color: #999'
                    : ''
                "
              >
                {{
                  item.warehouse.store_name === ""
                    ? "请选择装货位"
                    : `${item.warehouse.store_name} ${item.warehouse.warehouse_name}`
                }}
              </div>
              <div>
                <van-icon
                  name="arrow-down"
                  color="#999"
                  size="15px"
                  style="vertical-align: middle;margin-left: 3px;"
                />
              </div>
            </div>
          </div>
          <div style="padding: 10px 0px 10px 10px;display: flex;">
            <div class="left3">
              监装员(可选)
            </div>
            <div @click="openRepoMrg(index)" class="left2">
              <span
                :style="
                  item.repoMrgObj && item.repoMrgObj.name.length > 0
                    ? ''
                    : 'color: #999'
                "
                >{{
                  item.repoMrgObj && item.repoMrgObj.name.length > 0
                    ? item.repoMrgObj.name
                    : storeKeeper
                }}</span
              >
              <van-icon
                name="manager"
                color="#00C8D2"
                size="15px"
                style="vertical-align: middle;margin-left: 3px;"
              />
            </div>
          </div>
        </div>
        <div class="cont3-right">
          <van-icon
            name="clear"
            v-if="index === vehicleArr.length - 1"
            @click="deleteVehicle"
          />
          <!-- v-if="index === vehicleArr.length - 1 && vehicleArr.length > 1" -->
        </div>
      </div>
      <div class="cont3-bottom" @click="addVehicle">
        <van-icon name="add" size="22px" style="margin-right: 5px;" />添加车辆
      </div>
    </div>

    <div style="height: 86px;background-color: #f4f5f6;"></div>
    <div class="footer-cont" @click="clickCalling">
      <van-button type="primary" block class="btnStyle1">确认叫号</van-button>
    </div>

    <!-- 模拟键盘 -->
    <div class="allBoard">
      <van-popup
        v-model="show_allBoard1"
        position="bottom"
        :overlay="true"
        overlay-class="displayNone"
        id="keyBoard"
      >
        <div class="plate_number_box">
          <div
            size="small"
            v-for="(item, index) in storeArr"
            :key="index"
            class="btn-div"
            @click="selectStore(item)"
          >
            <div
              class="btn-div-cont"
              :style="item.tag === true ? 'background: #E6E6FA;' : ''"
            >
              <span v-if="item.id === 99"
                ><img
                  src="../assets/img/delete.png"
                  width="24px"
                  style="vertical-align: middle;"
              /></span>
              <span v-else :style="item.tag === true ? 'color: #666;' : ''">{{
                item.name
              }}</span>
            </div>
          </div>
        </div>
      </van-popup>
      <van-popup
        v-model="show_allBoard2"
        position="bottom"
        :overlay="true"
        overlay-class="displayNone"
      >
        <div class="plate_number_box">
          <div
            size="small"
            v-for="(item, index) in siteArr"
            :key="index"
            class="btn-div"
            @click="selectSite(item)"
          >
            <div
              class="btn-div-cont"
              :style="item.tag === true ? 'background: #E6E6FA;' : ''"
            >
              <span v-if="item.id === 99"
                ><img
                  src="../assets/img/delete.png"
                  width="24px"
                  style="vertical-align: middle;"
              /></span>
              <span v-else :style="item.tag === true ? 'color: #666;' : ''">{{
                item.name
              }}</span>
            </div>
          </div>
          <!-- <van-button
            size="small"
            v-for="(item, index) in siteArr"
            :key="index"
            style="vertical-align: top;"
            @click="selectSite(item)"
          >
            <span v-if="item.id === 99"
              ><img
                src="../assets/img/delete.png"
                width="24px"
                style="vertical-align: middle;"
            /></span>
            <span v-else :style="item.tag === true ? 'color: #666;' : ''">{{
              item.name
            }}</span>
          </van-button> -->
        </div>
      </van-popup>
    </div>

    <!-- 弹窗 -->
    <van-dialog
      v-model="dialogShow"
      show-cancel-button
      :showConfirmButton="false"
      :showCancelButton="false"
      max-height="70vh"
    >
      <template #default>
        <div class="dialog-blk">
          <div v-if="dialogType === 'calling'">
            当前已选择<span class="colorPink">{{ vehicleArr.length }}</span>
            车(<span
              class="colorPink"
              v-for="(item, index) in vehicleArr"
              :key="index"
            >
              {{ item.report_info.license_plate }} </span
            >)，确认执行叫号吗？这将立即呼叫车辆前往{{business_type == 1 ? '装车' : '卸货'}}位置！
          </div>
          <div v-if="dialogType === 'errorTip'" class="colorPink">
            “
            <span v-for="(item, index) in errorVehicleArr" :key="index">
              {{ item.code }}-{{ item.license_plate }}
            </span>
            ”正在装货作业中，无法对其执行叫号，已为您自动剔除！
          </div>
          <div class="block_reason" v-if="overTimeQueue.length > 0">
            <div v-for="(item, index) in overTimeQueue" :key="index">
              <!-- {{ item.reason }} -->
              <div class="overTime">
                <!-- 超时 -->
                <template>
                  <p class="actionQueueReasonTitle">
                    <span class="colorPink">{{ item.license_plate }}</span>
                    已超出{{ item.overTime }}分钟，请选择超时原因：
                  </p>
                  <el-select
                    v-model="item.selectReason"
                    popper-class="elSelectpopper"
                    placeholder="请选择超时原因"
                  >
                    <el-option
                      v-for="(item, index) in item.reason.list"
                      :key="index"
                      :label="item.name"
                      :value="item.name"
                    >
                    </el-option>
                  </el-select>
                  <van-field
                    v-model="item.selectNote"
                    rows="3"
                    autosize
                    label=""
                    type="textarea"
                    maxlength="50"
                    placeholder="请输入超时原因"
                    show-word-limit
                  />
                </template>
              </div>
            </div>
          </div>
        </div>
        <div style="display: flex;">
          <div style="flex: 1;" @click="cancelError">
            <van-button block class="dialogBtnCancel">
              {{ dialogType === "calling" ? "取消" : "我知道了" }}
            </van-button>
          </div>
          <div
            style="flex: 1;"
            @click="onConfirmCalling"
            v-if="dialogType === 'calling'"
          >
            <van-button block class="dialogBtnConfirm">确认</van-button>
          </div>
        </div>
      </template>
      <template #title>
        <div style="font-size: 15px;">
          {{ dialogType === "calling" ? "确认提示" : "异常提醒" }}
        </div>
      </template>
    </van-dialog>
    <wxGroupContact
      v-if="wxGroupContactObj.isCreat"
      :initUser="wxGroupContactObj.exUser"
      :getInitDataUrl="wxGroupContactObj.initUrl"
      :getDataUrl="wxGroupContactObj.exUserGetDataUrl"
      :labelUrl="wxGroupContactObj.labelUrl"
      :type="wxGroupContactObj.type"
      :multiSelect="wxGroupContactObj.multiSelect"
      @wxExcomfireSelect="wxGroupcomfireSelect"
      ref="wxExt"
    ></wxGroupContact>
  </div>
</template>
<script>
// import { Toast } from "vant";
import wxGroupContact from "@/components/wxGroupContact";
import { VEHICLE_TYPE_LIST } from "@/assets/js/vehicleTypeEnum";
export default {
  props: {},
  data() {
    return {
      isActive: "loading",
      dialogShow: false,
      dialogType: "calling",
      rejectReason: "", // 拒绝理由
      loadingSite: "请选择装货位",
      storeKeeper: "不选时默认自己",
      vehicleArr: [],
      vehicleColumns: VEHICLE_TYPE_LIST.map(v => v.name),
      show_allBoard1: false,
      show_allBoard2: false,
      storeArr: [],
      siteArr: [],
      queueList: [], // 排队列表
      storePeopleList: [], // 监装员列表
      storeList: [], // 仓列表
      wareHouseList: [], // 库列表
      params: {
        warehouse_id: ""
      },
      rowDataObj: {}, // 排队队列
      rowIndex: "",
      errorVehicleArr: [], // 错误车辆提示
      vehicleEditObjIndex: "", // 编辑监装员下标
      wxGroupContactObj: {
        showWxGroupContact: true,
        exUser: [],
        exUserGetDataUrl: "/api/tag/search_user_by_page",
        labelUrl: "/api/tag/get_by_type",
        initUrl: "/api/contact/id_to_name",
        type: "REPO_MGR",
        multiSelect: 1,
        isCreat: false
      },
      actionQueueOutTimeResoin: { list: [], other: false },
      overTimeQueue: []
    };
  },
  components: {
    wxGroupContact
  },
  computed: {
    business_id() {
      return this.$route.query.business_id;
    },
    business_type() {
      return this.$route.query.type;
    },
    type() {
      let type = false;
      // if (this.$route.query.type && (this.$route.query.type == 2 || this.$route.query.type == 3)) {
      if (this.$route.query.type && (this.$route.query.type == 2)) {
        // type = true;
        type = false; //成品入厂也可以选择装卸平台
      } else {
        type = false;
      }
      return type;
    }
  },
  async mounted() {
    this.getQueueList(); // 获取排队列表
    // this.getStorePeopleList(); // 获取监装员列表
    // this.getStoreList(); // 获取仓库列表
  },
  methods: {
    openRepoMrg(index) {
      // 查询初始换
      let repoMrgObj = this.vehicleArr[index].repoMrgObj || {};
      this.vehicleEditObjIndex = index;
      this.wxGroupContactObj.exUser = repoMrgObj.id ? [repoMrgObj.id] : [];
      this.wxGroupContactObj.isCreat = true;
    },
    wxGroupcomfireSelect(selectuser) {
      this.wxGroupContactObj.isCreat = false;
      this.vehicleArr[this.vehicleEditObjIndex].repoMrgObj = selectuser[0];
      this.vehicleArr[this.vehicleEditObjIndex].warehouseman_select_id =
        selectuser.length > 0 ? selectuser[0].id : "";
    },
    // 切换按钮
    changeBtn(tag) {
      this.isActive = tag;
    },

    // 取消
    onCancel() {
      this.dialogShow = false;
    },

    // 删除车辆
    deleteVehicle() {
      this.vehicleArr.pop();
    },

    // 选择仓库（获取装卸平台列表）
    selectStore(item) {
      this.siteArr = [];
      console.log(item.name, item.tag, item.tag === true);
      if (item.id === "") {
        return false;
      } else if (item.tag === true) {
        this.$common.mbToastFail("该仓库所有装卸平台正在作业中");
        return false;
      } else if (item.id === 99) {
        this.loadingSite = "请选择装货位";
      } else {
        this.show_allBoard1 = false;
        this.show_allBoard2 = true;
        this.loadingSite = item.name;
        this.vehicleArr[this.rowIndex].warehouse.store_name = item.name;
        this.vehicleArr[this.rowIndex].warehouse.warehouse_name = "";
        this.params.warehouse_id = item.id;
        this.$common
          .http({
            url: "/api/queue/warehouseman/query_warehouse",
            data: {
              state: 1,
              warehouse_id: this.params.warehouse_id,
              keyword: "",
              page_size: ""
            }
          })
          .then(res => {
            console.log(res.data.data);
            // this.siteArr = res.data.data;
            res.data.data.forEach(item => {
              if (item.queue_id !== "") {
                item.tag = true;
              } else {
                item.tag = false;
              }
              this.siteArr.push(item);
            });
            // 填充弹窗内容(为了使删除键靠右)
            let num = this.siteArr.length % 5;
            for (let i = 0; i < 4 - num; i++) {
              this.siteArr.push({
                name: "",
                id: "",
                tag: ""
              });
            }
            // 当库位小于五位时，加多一行
            if (res.data.data.length < 5) {
              for (let i = 0; i < 5; i++) {
                this.siteArr.push({
                  name: "",
                  id: "",
                  tag: ""
                });
              }
            }
            this.siteArr.push({
              name: "",
              id: 99,
              tag: ""
            });
          });
      }
    },

    // 选择仓库号位
    selectSite(item) {
      console.log(item.name);
      if (item.id === "") {
        return false;
      } else if (item.tag === true) {
        this.$common.mbToastFail("该装卸平台正在作业中");
        return false;
      } else if (item.id === 99) {
        this.show_allBoard2 = false;
        this.show_allBoard1 = true;
        // if (this.loadingSite.indexOf("位") > 0) {
        //   this.loadingSite = this.loadingSite.split(0, 2)[0];
        // }
      } else {
        this.loadingSite = this.loadingSite + item.name;
        this.vehicleArr[this.rowIndex].warehouse.warehouse_name = item.name;
        this.vehicleArr[this.rowIndex].warehouse_id = item.id;
        this.show_allBoard2 = false;
      }
    },

    // 添加车辆
    addVehicle() {
      if (this.vehicleArr.length >= this.rowDataObj.length) {
        this.$common.mbToastFail(`已添加完所有车辆`);
      } else {
        let copyRowDataObj = JSON.parse(JSON.stringify(this.rowDataObj));
        let addArr = copyRowDataObj.splice(this.vehicleArr.length, 1);
        this.vehicleArr.push(addArr[0]);
        console.log(this.vehicleArr);
      }
    },
    getOverTimeQueue() {
      console.log(this.vehicleArr);
      this.overTimeQueue = [];
      this.vehicleArr.forEach(item => {
        console.log(item);
        this.$common
          .http({
            url: "/api/queue/warehouseman/check_operation",
            data: {
              id: item.id
            }
          })
          .then(res => {
            let data = res.data.data;
            console.log(data);
            let nList = [];
            let reason =
              JSON.stringify(data) == "[]"
                ? this.actionQueueOutTimeResoin
                : JSON.parse(data.reason);
            reason.list.forEach((item, index) => {
              nList.push({ key: index, name: item });
            });
            if (reason.other) {
              nList.push({ key: "other", name: "其他" });
            }
            let overTime =
              parseInt(data.overtime / 60) == 0
                ? 1
                : parseInt(data.overtime / 60);
            reason.list = nList;
            if (data.state == false) {
              this.overTimeQueue.push({
                id: item.id,
                reason: reason,
                overTime: overTime,
                license_plate: item.report_info.license_plate,
                selectReason: "",
                selectNote: ""
              });
            }
            console.log("iniin", this.overTimeQueue);
          });
      });
    },

    // 点击“确认叫号”按钮
    clickCalling() {
      console.log(this.overTimeQueue);
      for (let i = 0; i < this.vehicleArr.length; i++) {
        if (
          (!this.vehicleArr[i].warehouse_id ||
            Number(this.vehicleArr[i].warehouse_id) === 0) &&
          !this.type
        ) {
          // 只有成品出厂必须选择装卸平台，其他类型待定
          if(this.business_type == 1){
            this.$common.mbToastFail(`${this.vehicleArr[i].code}未选择装卸平台`);
            return;
          }
        }
      }
      this.getOverTimeQueue();
      this.dialogShow = true;
    },

    // 确认叫号
    onConfirmCalling() {
      let data = [];
      for (let i = 0; i < this.vehicleArr.length; i++) {
        console.log(this.vehicleArr[i]);
        this.overTimeQueue.map(item => {
          if (this.vehicleArr[i].id == item.id) {
            this.vehicleArr[i].overtime_reason = item.selectReason;
            this.vehicleArr[i].note = item.selectNote;
          }
        });
        if (
          this.vehicleArr[i].overtime_reason == "其他" &&
          this.vehicleArr[i].note == ""
        ) {
          this.$common.mbToastFail(
            this.vehicleArr[i].report_info.license_plate + "未输入超时原因"
          );
          return false;
        }
        let obj = {
          queue_id: this.vehicleArr[i].id,
          warehouse_id: this.vehicleArr[i].warehouse_id,
          warehouseman_id: this.vehicleArr[i].warehouseman_select_id || "",
          overtime_reason: this.vehicleArr[i].overtime_reason
            ? this.vehicleArr[i].overtime_reason
            : "",
          note: this.vehicleArr[i].note ? this.vehicleArr[i].note : ""
        };
        if (!this.type) {
          obj.warehouse_id = this.vehicleArr[i].warehouse_id;
          obj.type = 1;
        } else {
          obj.type = 2;
          obj.warehouse_id = "";
        }
        data.push(obj);
      }
      this.$common
        .http({
          url: "/api/queue/warehouseman/call_queue",
          data: {
            operate_data: JSON.stringify(data)
          }
        })
        .then(res => {
          this.dialogShow = false;
          let obj = res.data.data;
          if (Number(obj.state) === 1) {
            for (let i = 0; i < obj.loading_queue.length; i++) {
              for (let j = 0; j < this.vehicleArr.length; j++) {
                if (this.vehicleArr[j].id === obj.loading_queue[i]) {
                  // 错误提示
                  this.errorVehicleArr.push({
                    code: this.vehicleArr[j].code,
                    id: this.vehicleArr[j].id,
                    license_plate: this.vehicleArr[j].report_info.license_plate
                  });
                }
              }
            }
            this.dialogType = "errorTip";
            this.dialogShow = true;
          } else {
            this.$common.mbToastSuccess("叫号成功");
            setTimeout(() => {
              this.$router.history.go(-1);
            }, 1000);
          }
        });
    },

    // 我知道了
    cancelError() {
      this.dialogShow = false;
      if (this.dialogType === "errorTip") {
        // 更新当前选中车辆的信息
        for (let i = 0; i < this.vehicleArr.length; i++) {
          for (let j = 0; j < this.errorVehicleArr.length; j++) {
            if (this.errorVehicleArr[j].id === this.vehicleArr[i].id) {
              this.vehicleArr.splice(i, 1);
            }
          }
        }
        // 更新队列车辆的信息
        for (let i = 0; i < this.rowDataObj.length; i++) {
          for (let j = 0; j < this.errorVehicleArr.length; j++) {
            if (this.errorVehicleArr[j].id === this.rowDataObj[i].id) {
              this.rowDataObj.splice(i, 1);
            }
          }
        }
      }
      this.dialogType = "calling";
    },

    // 获取排队列表
    getQueueList() {
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_loading_queue",
          data: {
            business_id: this.business_id,
            work_state: 1
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.rowDataObj = res.data.data;
          let copyRowDataObj = JSON.parse(JSON.stringify(this.rowDataObj));
          this.vehicleArr = copyRowDataObj.splice(0, 1);
        });
    },

    // 获取监装员列表
    // getStorePeopleList() {
    //   // this.storePeopleList = [
    //   //   {
    //   //     name: "张三",
    //   //     userId: 111111
    //   //   },
    //   //   {
    //   //     name: "李四",
    //   //     userId: 222222
    //   //   }
    //   // ];
    //   this.$common
    //     .http({
    //       url: "/api/queue/warehouseman/query_loading_queue",
    //       data: {
    //         business_id: this.business_id,
    //         work_state: 1
    //       }
    //     })
    //     .then(res => {
    //       console.log(res.data.data);
    //       this.queueList = res.data.data;
    //     });
    // },

    // 获取仓列表
    getStoreList() {
      this.storeArr = [];
      this.$common
        .http({
          url: "/api/queue/warehouseman/query_warehouse",
          data: {
            state: 1,
            warehouse_id: "",
            keyword: "",
            page_size: "",
            is_free: 1
          }
        })
        .then(res => {
          console.log(res.data.data.length < 5);
          // this.storeArr = res.data.data;
          res.data.data.forEach(item => {
            if (item.queue_id !== "") {
              item.tag = true;
            } else {
              item.tag = false;
            }
            this.storeArr.push(item);
          });
          // 填充弹窗内容(为了使删除键靠右)
          let num = this.storeArr.length % 5;
          for (let i = 0; i < 4 - num; i++) {
            this.storeArr.push({
              name: "",
              id: "",
              tag: ""
            });
          }
          // 当仓库位小于五位时，加多一行
          if (res.data.data.length < 5) {
            for (let i = 0; i < 5; i++) {
              this.storeArr.push({
                name: "",
                id: "",
                tag: ""
              });
            }
          }
          this.storeArr.push({
            name: "",
            id: 99,
            tag: ""
          });
        });
    },

    // 弹起仓库键盘
    showStore(item) {
      this.getStoreList();
      this.show_allBoard1 = true;
      this.rowIndex = item;
    }
  },
  created() {
    // 登录调试
    // this.$common.http({
    //   url: "/api/queue/warehouseman/query_queue"
    // });
  }
};
</script>
<style lang="less" scoped>
@import "../assets/css/common";
.storeCallDiv {
  min-height: 100vh;
  box-sizing: border-box;
  border-top: 1px solid #fff;
  background: #f4f5f6;
  .cont3 {
    background: #fff;
    padding: 10px 16px 16px;
    margin: 0px 0 10px;
    &-title {
      font-size: 15px;
      padding-bottom: 14px;
    }
    &-left {
      font-size: 13px;
      line-height: 22px;
      padding: 0px 0px 7px;
      flex: 3.9;
      color: #4f4a4c;
      .top {
        background: #00c8d2;
        box-shadow: 0 2px 4px 0 rgba(0, 200, 210, 0.1);
        border-radius: 4px 0 13px 0;
        text-align: center;
        color: white;
        font-size: 18px;
        margin-bottom: 14px;
        padding: 2px 11px;
        display: inline-block;
        min-width: 35px;
      }
      .left1 {
        line-height: 26px;
        font-size: 18px;
        color: #000;
        flex: 1;
      }
      .left2 {
        flex: 1.7;
        margin-top: 2px;
        font-size: 14px;
        display: flex;
        align-items: center;
        .left2-div1 {
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
          max-width: 178px;
        }
      }
      .left3 {
        flex: 1;
        font-size: 14px;
      }
    }
    &-right {
      // flex: 1;
      text-align: right;
      margin-top: flex;
      margin-top: -5px;
      font-size: 24px;
      color: #dfdfe0;
      & > div {
        flex: 1;
        text-align: right;
      }
      .icons {
        font-size: 15px;
        color: #999;
        vertical-align: middle;
        margin-left: 5px;
      }
    }
    &-bottom {
      color: #009967;
      font-size: 17px;
      padding: 7px 0px 0px;
      display: flex;
      align-items: center;
    }
  }
  .mgBottom10 {
    margin-bottom: 10px;
  }

  // .allBoard .plate_number_box .van-button--small {
  //   width: 20%;
  //   height: 12.9vw;
  // }
  // .allBoard .plate_number_box .van-button::before {
  //   display: none;
  // }
  // .van-button--small {
  //   font-size: 16px;
  // }
  // .van-overlay {
  //   background-color: inherit;
  // }
  .plate_number_box {
    display: flex;
    width: 100%;
    text-align: center;
    align-content: center;
    flex-flow: row wrap;
  }
  .btn-div {
    word-break: break-all;
    border: 1px solid #f0f1f4;
    // padding: 5px 8px;
    vertical-align: top;
    /* flex: 15%; */
    width: 20%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    min-height: 53px;
  }
  .btn-div-cont {
    padding: 5px 8px;
    width: 100%;
    height: calc(100% - 10px);
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .dialog-blk {
    text-align: left;
    .block_reason {
      max-height: 50vh;
      overflow-y: auto;
    }
  }
}
</style>
<style lang="less">
.allBoard > .van-overlay {
  background-color: inherit;
}
.storeCallDiv {
  .overTime {
    margin-top: 8px;
    .actionQueueReasonTitle {
      margin: 0;
      padding-bottom: 5px;
    }
    .el-select .el-input.is-focus .el-input__inner,
    .el-select .el-input__inner:focus {
      border-color: rgb(192, 196, 204) !important;
    }
  }
}
.van-cell {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  margin-top: 8px;
  color: #606266;
}
.el-select {
  width: 100%;
}
.el-select-dropdown__item.selected {
  color: #008b5e !important;
}
.elSelectpopper {
  z-index: 5000 !important;
}
.el-select-dropdown {
  width: 285px;
}
.vanDialog .van-cell {
  margin-top: 5px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  textarea::-webkit-input-placeholder {
    color: rgb(192, 196, 204);
  }
}
// .el-scrollbar__wrap {
//   width: 300px;
//   box-sizing: border-box;
// }
.el-scrollbar {
  > .el-scrollbar__bar {
    opacity: 1 !important;
  }
}
</style>
